import { useCookieState } from "@/app/[lng]/_components/cookie-provider";
import { useCallback, useMemo } from "react";
import Cookie from "js-cookie";

export type AnalyticsState = {
  isStatisticsOn: boolean;
  isMarketingOn: boolean;
  isSentryOn: boolean;
};

export function useAnalyticsState() {
  const [cookies, setCookie] = useCookieState();
  const analyticsCookie = useMemo(() => {
    const cookie = cookies["mb-cookie-consent"];
    return cookie ? (JSON.parse(cookie) as AnalyticsState) : undefined;
  }, [cookies]);

  const setAnalyticsCookie = useCallback(
    (
      newState:
        | AnalyticsState
        | ((prev: AnalyticsState) => Partial<AnalyticsState>),
    ) => {
      const updatedState =
        typeof newState === "function"
          ? {
              ...analyticsCookie,
              ...newState(
                analyticsCookie ?? {
                  isStatisticsOn: false,
                  isMarketingOn: false,
                  isSentryOn: false,
                },
              ),
            }
          : { ...analyticsCookie, ...newState };
      setCookie("mb-cookie-consent", JSON.stringify(updatedState));
    },
    [analyticsCookie, setCookie],
  );

  return { analyticsCookie, setAnalyticsCookie };
}

export function getAnalyticsCookie(): AnalyticsState | undefined {
  const cookie = Cookie.get("mb-cookie-consent");
  return cookie ? JSON.parse(cookie) : undefined;
}
